export default {
  sm: `
  Results of state-of-<br> 
  the-art industries<br>  
  concentrated in<br> 
  DATA CENTER GAK<br>  
  Sejong
  `,
  md: `
  Results of state-of-the-art<br> 
  industries concentrated in<br>
  DATA CENTER GAK Sejong
  `,
  lg: `
  Results of state-of-the-art<br> 
  industries concentrated in<br>
  DATA CENTER GAK Sejong
  `,
  xxl: `
  Results of state-of-the-art<br> 
  industries concentrated in<br>
  DATA CENTER GAK Sejong
  `,
};
